import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const SubmitMainForm = lazy(() => import('@components/Submit/SubmitMainForm'));

/** 기업보고서 제출화면 */
const SubmitMain = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense>
          <SubmitMainForm />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default SubmitMain;
